import { createContext } from "react";

function isMobile () {
  var userAgentInfo = navigator.userAgent;

  var mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];

  var mobile_flag = false;

  //根据userAgent判断是否是手机
  for (var v = 0; v < mobileAgents.length; v++) {
    if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
      mobile_flag = true;
      break;
    }
  }

  var screen_width = window.screen.width;
  var screen_height = window.screen.height;

  //根据屏幕分辨率判断是否是手机
  if (screen_width < 500 && screen_height < 800) {
    mobile_flag = true;
  }

  return mobile_flag;
}

export const defaultState = {
  newsTypeList: [
    { "id": "381111440867594240", "pid": "0", "name": "zxzx" },
    { "id": "381111485272690688", "pid": "0", "name": "xsygh" },
    { "id": "381111636359909376", "pid": "0", "name": "kpyd" },
    { "id": "381111376904458240", "pid": "0", "name": "pphd" },
    { "id": "29", "pid": "0", "name": "hyfc" },
    { "id": "381111858095984640", "pid": "0", "name": "jstx" },
    { "id": "381111757956976640", "pid": "0", "name": "bzh" },
    { "id": "28", "pid": "0", "name": "kjfw" },
    { "id": "1", "pid": "0", "name": "gyxh" }
  ],
  menuList: {
    "gyxh":
      [
        { "title": "ddjs", "path": "/list?title=gyxh/ddjs&id=381112432866627584", "id": "381112432866627584", "pid": "1" }, //2024-12-27 党团组织改为党的建设
        { "title": "xhjj", "path": "/detail?title=gyxh/xhjj&id=12" },
        { "title": "xhzc", "path": "detail?title=gyxh/xhzc&id=13&cid=8", "id": "13", "pid": "8" },
        { "title": "zzjg", "path": "/list?title=gyxh/zzjg&id=9", "id": "9", "pid": "1" },
        { "title": "lshmd", "path": "/list?title=gyxh/lshmd&id=10", "id": "10", "pid": "1" },
        { "title": "jshmd", "path": "/list?title=gyxh/jshmd&id=924966205935063040", "id": "924966205935063040", "pid": "1" },
        { "title": "fzjg", "path": "/list?title=gyxh/fzjg&id=381112353791414272", "id": "381112353791414272", "pid": "1" },
        { "title": "dsxh", "path": "/list?title=gyxh/dsxh&id=381112395130474496", "id": "381112395130474496", "pid": "1" },
        { "title": "glbf", "path": "/list?title=gyxh/glbf&id=381112480799133696", "id": "381112480799133696", "pid": "1" },
        { "title": "jrxh", "path": "/list?title=gyxh/jrxh&id=381112547027193856", "id": "381112547027193856", "pid": "1" },
        { "title": "lxwm", "path": "/detail?title=gyxh/lxwm&id=75" }],
    "hyfc":
      [
        { "title": "hydw", "path": "/list?title=hyfc/hydw&id=27", "id": "27", "pid": "29" },
        { "title": "hydt", "path": "/list?title=hyfc/hydt&id=381773913824169984", "id": "381773913824169984", "pid": "29" },
        { "title": "hzxq", "path": "/list?title=hyfc/hzxq&id=381774025614954496", "id": "381774025614954496", "pid": "29" }
      ],
    "pphd":
      [
        { "title": "sjdxhxxshrjndh", "path": "/list?title=pphd/sjdxhxxshrjndh&id=381770895015809024", "id": "381770895015809024", "pid": "381111376904458240" },
        { "title": "jsxxtxhykxjsj", "path": "/list?title=pphd/jsxxtxhykxjsj&id=381771042311376896", "id": "381771042311376896", "pid": "381111376904458240" },
        { "title": "qnxslt", "path": "/list?title=pphd/qnxslt&id=381770974833414144", "id": "381770974833414144", "pid": "381111376904458240" },
        { "title": "lwzj", "path": "/list?title=pphd/lwzj&id=381771113249640448", "id": "381771113249640448", "pid": "381111376904458240" }
      ],
    "zxzx":
      [
        { "title": "ggl", "path": "/list?title=zxzx/ggl&id=24", "id": "24", "pid": "381111440867594240" },
        { "title": "xhdt", "path": "/list?title=zxzx/xhdt&id=381773605383442432", "id": "381773605383442432", "pid": "381111440867594240" },
        { "title": "fzjgdt", "path": "/list?title=zxzx/fzjgdt&id=381773690049662976", "id": "381773690049662976", "pid": "381111440867594240" },
        { "title": "dsxhdt", "path": "/list?title=zxzx/dsxhdt&id=381773782571814912", "id": "381773782571814912", "pid": "381111440867594240" }
      ],
    "xsygh":
      [
        { "title": "qyjs", "path": "/list?title=xsygh/qyjs&id=381771372700897280", "id": "381771372700897280", "pid": "381111485272690688" },
        { "title": "fgyzc", "path": "/list?title=xsygh/fgyzc&id=381771471984267264", "id": "381771471984267264", "pid": "381111485272690688" },
        { "title": "ghyfz", "path": "/list?title=xsygh/ghyfz&id=381771680910938112", "id": "381771680910938112", "pid": "381111485272690688" },
        { "title": "hyyw", "path": "/list?title=xsygh/hyyw&id=381771537067282432", "id": "381771537067282432", "pid": "381111485272690688" }
      ],
    "kpyd":
      [
        { "title": "kpzp", "path": "/list?title=kpyd/kpzp&id=381774691309719552", "id": "381774691309719552", "pid": "381111636359909376" },
        { "title": "kpsp", "path": "/list?title=kpyd/kpsp&id=381774742463451136", "id": "381774742463451136", "pid": "381111636359909376" },
        { "title": "kpcg", "path": "/list?title=kpyd/kpcg&id=381774802517495808", "id": "381774802517495808", "pid": "381111636359909376" }
      ],
    "kjfw":
      [
        { "title": "zxyzk", "path": "/list?title=kjfw/zxyzk&id=381774871266332672", "id": "381774871266332672", "pid": "28" },
        { "title": "kjpj", "path": "/list?title=kjfw/kjpj&id=381774929462300672", "id": "381774929462300672", "pid": "28" }
      ],
    "bzh":
      [
        { "title": "ttbz", "path": "/list?title=bzh/ttbz&id=384747514751881216", "id": "384747514751881216", "pid": "381111757956976640" },
        { "title": "dfbz", "path": "/list?title=bzh/dfbz&id=381774586749915136", "id": "381774586749915136", "pid": "381111757956976640" },
        { "title": "hybz", "path": "/list?title=bzh/hybz&id=381774529304727552", "id": "381774529304727552", "pid": "381111757956976640" },
        { "title": "gjbz", "path": "/list?title=bzh/gjbz&id=381774362702778368", "id": "381774362702778368", "pid": "381111757956976640" }
      ],
    "jstx":
      [
        { "title": "jqml", "path": "/list?title=jstx/jqml&id=381774983724011520", "id": "381774983724011520", "pid": "381111858095984640" },
        { "title": "zgqs", "path": "/list?title=jstx/zgqs&id=381775032063365120", "id": "381775032063365120", "pid": "381111858095984640" },
        { "title": "lwj", "path": "/list?title=jstx/lwj&id=381775086006308864", "id": "381775086006308864", "pid": "381111858095984640" }
      ]
  },
  isMobile: isMobile(),
  menuTypeList: {
    zxzx: '资讯中心',
    ggl: '公告栏',
    xhdt: '学会动态',
    fzjgdt: '分支机构动态',
    dsxhdt: '地市学会动态',
    xsygh: '学术与规划',
    qyjs: '前瞻技术',
    fgyzc: '法规与政策',
    ghyfz: '规划与发展',
    hyyw: '行业要闻',
    kpyd: '科普园地',
    kpzp: '科普作品',
    kpsp: '科普视频',
    kpcg: '科普场馆',
    pphd: '品牌活动',
    sjdxhxxshrjndh: '世界电信和信息社会日纪念大会',
    jsxxtxhykxjsj: '江苏信息通信行业科学技术奖',
    qnxslt: '青年学术论坛',
    lwzj: '论文征集',
    hyfc: '会员之家',
    hydw: '会员单位',
    hydt: '会员动态',
    hzxq: '合作需求',
    jstx: '《江苏通信》',
    jqml: '近期目录',
    zgqs: '征稿启事',
    lwj: '论文集',
    bzh: '标准化',
    ttbz: '团体标准',
    dfbz: '地方标准',
    hybz: '行业标准',
    gjbz: '国家标准',
    kjfw: '科技服务',
    zxyzk: '咨询与智库',
    kjpj: '科技评价',
    gyxh: '关于学会',
    ddjs: '党的建设', //2024-12-27 党团组织改为党的建设
    xhjj: '学会简介',
    xhzc: '学会章程',
    zzjg: '组织架构',
    lshmd: '理事会名单',
    jshmd: '监事会名单',
    fzjg: '分支机构',
    dsxh: '地市学会',
    glbf: '管理办法',
    jrxh: '加入学会',
    lxwm: '联系我们',
  },
  menuTitleList: {
    '资讯中心': 'zxzx',
    '公告栏': 'ggl',
    '学会动态': 'xhdt',
    '分支机构动态': 'fzjgdt',
    '地市学会动态': 'dsxhdt',
    '学术与规划': 'xsygh',
    '前瞻技术': 'qyjs',
    '法规与政策': 'fgyzc',
    '规划与发展': 'ghyfz',
    '行业要闻': 'hyyw',
    '科普园地': 'kpyd',
    '科普作品': 'kpzp',
    '科普视频': 'kpsp',
    '科普场馆': 'kpcg',
    '品牌活动': 'pphd',
    '世界电信和信息社会日纪念大会': 'sjdxhxxshrjndh',
    '江苏信息通信行业科学技术奖': 'jsxxtxhykxjsj',
    '青年学术论坛': 'qnxslt',
    '论文征集': 'lwzj',
    '会员之家': 'hyfc',
    '会员单位': 'hydw',
    '会员动态': 'hydt',
    '合作需求': 'hzxq',
    '《江苏通信》': 'jstx',
    '近期目录': 'jqml',
    '征稿启事': 'zgqs',
    '论文集': 'lwj',
    '标准化': 'bzh',
    '团体标准': 'ttbz',
    '地方标准': 'dfbz',
    '行业标准': 'hybz',
    '国家标准': 'gjbz',
    '科技服务': 'kjfw',
    '咨询与智库': 'zxyzk',
    '科技评价': 'kjpj',
    '关于学会': 'gyxh',
    '党的建设': 'ddjs',
    '学会简介': 'xhjj',
    '学会章程': 'xhzc',
    '组织架构': 'zzjg',
    '理事会名单': 'lshmd',
    '监事会名单': 'jshmd',
    '分支机构': 'fzjg',
    '地市学会': 'dsxh',
    '管理办法': 'glbf',
    '加入学会': 'jrxh',
    '联系我们': 'lxwm',
  },
}

export function reducer (state, action) {
  switch (action.type) {
    case 'SET_NEWSTYPELIST':
      return { ...state, newsTypeList: action.payload.data };
    case 'SET_MENULIST':
      return { ...state, menuList: action.payload.data };

    default:
      throw new Error();
  }
}

export const Context = createContext(null);
